'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentName = void 0;
/**
 * Names of the consents.
 * @export
 * @enum {number}
 */
var ConsentName;
(function (ConsentName) {
    ConsentName["EMAIL"] = "EMAIL";
    ConsentName["SMS"] = "SMS";
    ConsentName["TELEPHONE"] = "TELEPHONE";
    ConsentName["MAIL"] = "POST_MAIL";
    ConsentName["ONSITE_MARKETING"] = "ONSITE_PERSONALISED_MARKETING";
    ConsentName["TERMS"] = "TERMS_AND_CONDITIONS";
    ConsentName["EMAIL_GIG"] = "EMAIL_GIG";
    ConsentName["SMS_GIG"] = "SMS_GIG";
    ConsentName["TELEPHONE_GIG"] = "TELEPHONE_GIG";
    ConsentName["MAIL_GIG"] = "POST_MAIL_GIG";
    ConsentName["PRIVACY_COOKIE_POLICY"] = "PRIVACY_AND_COOKIE_NOTICE";
    ConsentName["DETAILS_REVERIFICATION"] = "DETAILS_REVERIFICATION";
    ConsentName["PROMOTIONAL_OFFERS"] = "PROMOTIONAL_OFFERS";
})(ConsentName = exports.ConsentName || (exports.ConsentName = {}));
